import BaseService from './baseService';

export default class EnelytixBillingService extends BaseService {
    constructor() {
        super('enelytixBilling');
    }

    /**
    * Gets data for billing grid
    * @param {Object} filter 
    * @param {Date | string | null} filter.startDate - start date
    * @param {Date | string | null} filter.endDate - end date
    * @param {string | null} filter.searchString - search string
    * @param {number} filter.pageNumber - page number
    * @param {number} filter.pageSize - page size
    * @returns returns 
    */
    getEnelytixBilling = (filter: {
        startDate: Date | string | null;
        endDate: Date | string | null;
        searchString: string | null;
        pageNumber: number;
        pageSize: number;
    }) => this.httpPostRequest('list', filter);

    /**
    * Gets link for download billing data
    * @param {Object} filter 
    * @param {Date | string | null} filter.startDate - start date
    * @param {Date | string | null} filter.endDate - end date
    * @param {string | null} filter.searchString - search string
    * @param {number} filter.pageNumber - page number
    * @param {number} filter.pageSize - page size
    * @returns returns link for download
    */
    downloadEnelytixBillingSearchResult = (filter: {
        startDate: Date | string | null;
        endDate: Date | string | null;
        searchString: string | null;
        pageNumber: number;
        pageSize: number;
    }) => this.httpPostRequest('download', filter);

}
